import React from "react";
import PersonList from "./PersonList.js";
import KeywordList from "./KeywordList.js";
import ListList from "./ListList.js";
import { ObjectConnectionsDiv } from "./elements";

const ObjectConnections = ({
  people,
  keywords,
  pdfs,
  images,
  timelineEntries,
  walks,
}) => (
  <ObjectConnectionsDiv>
    <h2>Connections</h2>
    <div>
      {people && people.length ? <PersonList people={people} /> : null}
      {keywords && keywords.length ? <KeywordList keywords={keywords} /> : null}
      {pdfs && pdfs.length ? (
        <ListList list={pdfs} slug="pdf" title={"PDFs"} />
      ) : null}
      {images && images.length ? (
        <ListList list={images} slug="image" title={"Images"} />
      ) : null}
      {timelineEntries && timelineEntries.length ? (
        <ListList
          list={timelineEntries}
          slug="event"
          title={"Timeline entries"}
        />
      ) : null}
      {walks && walks.length ? (
        <ListList list={walks} slug={"walk"} title={"Walks"} />
      ) : null}
    </div>
  </ObjectConnectionsDiv>
);

export default ObjectConnections;
